var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('validation-observer',{ref:"form",scopedSlots:_vm._u([{key:"default",fn:function(ref){
var handleSubmit = ref.handleSubmit;
return [_c('form',{staticClass:"entity-form-provider"},[_vm._t("default",null,null,{
        loading: _vm.loading,
        loadingConfig: _vm.loadingConfig,
        saving: _vm.saving,
        fields: _vm.fields,
        rawModel: _vm.rawModel,
        errorsObject: _vm.errorsObject,
        disableTag: _vm.disableTag,
        disabled: _vm.disabled,
        tabs: _vm.tabs,
        lazyTabs: _vm.lazyTabs,
        conditionalTabs: _vm.conditionalTabs,
        methods: {
          saveEntity: _vm.saveEntity,
          getFieldsByTag: _vm.getFieldsByTag,
          getFieldsWithAnyTag: _vm.getFieldsWithAnyTag,
          getFieldsWithAllTags: _vm.getFieldsWithAllTags,
          getFieldsWithoutTags: _vm.getFieldsWithoutTags,
          restartState: _vm.restartState,
          handleSubmit: handleSubmit,
          getWithShowMoreButton: _vm.getWithShowMoreButton,
          getGroupByTabs: _vm.getGroupByTabs,
          prepareToSave: _vm.prepareToSave,
        },
      })],2)]}}],null,true)})}
var staticRenderFns = []

export { render, staticRenderFns }